import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);

class SellPurchaseService {
  static addSeller = (appId, payload) => api.post(`${urls.SELLPURCHASE.COMMON_ENDPOINT}/${appId}/seller`, payload);

  static removeSeller = (appId, payload) =>
    api.deleteWithBody(`${urls.SELLPURCHASE.COMMON_ENDPOINT}/${appId}/seller`, null, payload);

  static addBuyer = (appId, payload) => api.post(`${urls.SELLPURCHASE.COMMON_ENDPOINT}/${appId}/buyer`, payload);

  static deleteBuyer = (appId, payload) =>
    api.deleteWithBody(`${urls.SELLPURCHASE.COMMON_ENDPOINT}/${appId}/buyer`, null, payload);

  static fetchPOAs = (id, params) => api.get(`${urls.SELLPURCHASE.COMMON_ENDPOINT}/${id}/representative`, null, params);

  static addRepresentative = (id, payload) =>
    api.post(`${urls.SELLPURCHASE.COMMON_ENDPOINT}/${id}/representative`, payload);

  static deleteRepresentative = (id, payload) =>
    api.deleteWithBody(`${urls.SELLPURCHASE.COMMON_ENDPOINT}/${id}/representative`, null, payload);

  static saveApplication = (appId, payload) => api.post(`${urls.SELLPURCHASE.COMMON_ENDPOINT}/${appId}/save`, payload);

  static sellerApproval = payload => api.post(urls.SELLPURCHASE.SELLER_APPROVAL, payload);

  static buyerApproval = payload => api.post(urls.SELLPURCHASE.BUYER_APPROVAL, payload);

  static fetchBreakDown = id => api.get(urls.SELLPURCHASE.FETCH_BREAKDOWN, id);

  static initiateSigningContract = params => api.post(urls.SELLPURCHASE.INITIATE_SIGNING_CONTRACT, null, params);

  static downloadContract = params => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/octet-stream;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.SELLPURCHASE.DOWNLOAD_CONTRACT, null, params);
  };

  // ------------------ previous work -------------------- //

  static fetchEvaluationPrice = appId => api.get(urls.SELLPURCHASE.EVALUATION_PRICE, `${appId}/evaluation-amount`);

  static fetchFeeCalculate = (payload, appId) =>
    api.post(`${urls.SELLPURCHASE.FEE_CALCULATE}/${appId}/fee-calculate`, payload);

  // property owner with right hold type ownership
  static fetchOwners = propertyId => api.get(urls.PROPERTY.OWNER, propertyId);

  static fetchAppoinmenWorkinghours = id => api.get(`${urls.SELLPURCHASE.WORKING_HOURS}/${id}/working-hours`);

  static fetchAppoinmentDetail = id => api.get(urls.SELLPURCHASE.APPOINMENT_LOCATION, id);

  static fetchOwnerDetails = id => api.get(urls.OWNER.FETCH_OWNER, id);

  static fetchApplicationDetails = id => api.get(urls.SELLPURCHASE.APPLICATION_DETAILS, id);

  static fetchApplicationDocuments = data => api.get(urls.DOCUMENT.FETCH_DOCUMENTS, null, data);

  static submitApplication = appId => api.get(urls.SELLPURCHASE.SUBMIT_APPLICATION, appId);

  static addBroker = (type, payload) => api.post(`${urls.SELLPURCHASE.ADD_BROKER}/${type}`, payload);

  static saveAppoinmentData = (appId, payload) =>
    api.post(`${urls.SELLPURCHASE.SAVE_APPOINMENT_SALE}/${appId}/save`, payload);

  static deleteBroker = type => api.deleteWithBody(`${urls.SELLPURCHASE.ADD_BROKER}/${type}`, null, null);

  static checkoutApplication = id => api.post(`${urls.SELLPURCHASE.CHECKOUT}/${id}/checkout`);

  static checkoutAutitor = id => api.post(`${urls.SELLPURCHASE.CHECKOUT}/${id}/appointment-checkout`);

  static fetchProperty = appId => api.get(`${urls.SELLPURCHASE.PROPERTY}/${appId}/property`);
}

export default SellPurchaseService;
